import { CommonBusinessObject } from '@iotv/iotv-v3-types'
import { IGeofence } from '../../ModelClassInterfaces/Geo'
import { AreaSubType, AreaSubTypeEnum } from '../../types/AreaTypes'
import { GeofencePointsType, UserAttributeDefs } from '../../types/ModelTypes'
import { Geofence } from './Geofence'

const debug = process.env.REACT_APP_DEBUG && false

const typeName = 'Area'

export interface IArea {
  color?: string
  opacity?: string
  lineWidth?: string
  lastPoint?: GeofencePointsType
}

export class Area extends Geofence implements IArea {
  color: string | undefined
  opacity: string | undefined
  lineWidth: string | undefined
  lastPoint: GeofencePointsType | undefined
  /** An entry from {@link AreaSubType} */
  subType: string
  /** @deprecated in favour of {@link AreaSubType} */
  theme: string | undefined

  constructor(ob: IArea & CommonBusinessObject & Partial<IGeofence>) {
    super({ ...ob, type: ob.type ?? typeName })
    this.color = ob.color
    this.opacity = ob.opacity
    this.lastPoint = ob.lastPoint
    this.subType = ob.subType
    this.theme = ob.theme
  }

  getUserAttributes(): UserAttributeDefs {
    return {
      name: { type: 'String', editable: true, required: true, label: 'Name', name: 'name', description: 'identification', validation: undefined },
      description: { type: 'String', editable: true, label: 'Description', description: 'description' },
      subType: { type: 'Enum', editable: true, required: true, label: 'Subtype', description: 'subtype', enumKv: AreaSubTypeEnum },
    }
  }
}
